<template>
  <div>
    <div class="phoneMenu">
      <a
        @click="myMenu = !myMenu"
        @touchstart="lockBkg"
        @touchmove="movePhoneMenu"
        @touchend="unlockBkg"
      >
        <i class="fas fa-bars fa-3x" v-if="!myMenu"></i>
        <i class="fas fa-times fa-3x" v-else></i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      phoneMenuIstouched: false,
      lastMenuPosition: [-1, -1],
      direction: "",
      menuWidth: 0,
      phoneMenu: null,
    };
  },

  props: ["menu"],
  mounted() {
    // this.$nextTick(() => {
    //   this.phoneMenu = document.getElementsByClassName("phoneMenu")[0];
    // });
  },

  computed: {
    myMenu: {
      get() {
        return this.menu;
      },
      set(val) {
        return this.$emit("update:menu", val);
      },
    },
  },

  methods: {
    //methods to move phone menu button
    movePhoneMenu(event) {
      event.preventDefault();
      //if fast direction order
      if (
        Math.abs(this.lastMenuPosition[0] - event.touches[0].clientX) > 35 ||
        Math.abs(this.lastMenuPosition[1] - event.touches[0].clientY) > 35
      ) {
        if (this.lastMenuPosition[0] !== -1) {
          if (this.lastMenuPosition[0] - event.touches[0].clientX > 35) {
            this.direction = "E";
          } else if (
            this.lastMenuPosition[0] - event.touches[0].clientX <
            -35
          ) {
            this.direction = "O";
          } else if (this.lastMenuPosition[1] - event.touches[0].clientY < 35) {
            this.direction = "S";
          } else this.direction = "N";
        }
      }
      this.phoneMenu.style.borderTopRightRadius = "50%";

      this.phoneMenu.style.left = "0";
      this.phoneMenu.style.top = "0";
      this.phoneMenu.style.transform =
        "translate3d(" +
        (event.touches[0].clientX - this.menuWidth) +
        "px, " +
        (event.touches[0].clientY - this.menuWidth) +
        "px, 30px)";

      this.lastMenuPosition = [
        event.touches[0].clientX,
        event.touches[0].clientY,
      ];
    },

    lockBkg(event) {
      this.phoneMenu = document.getElementsByClassName("phoneMenu")[0];
      this.phoneMenu.style.transition = "unset";

      // event.preventDefault();

      document.getElementsByTagName("body")[0].style.overflow = "hidden";
      this.menuWidth = this.phoneMenu.offsetWidth / 2;
    },
    unlockBkg() {
      let maxRight = window.innerWidth - this.phoneMenu.offsetWidth + 10;
      let maxBottom = window.innerHeight - this.phoneMenu.offsetHeight + 10;
      if (this.direction !== "") {
        this.phoneMenu.style.transform = "unset";
        this.phoneMenu.style.transition = "all .5s ease";
      }

      switch (this.direction) {
        case "N":
          this.phoneMenu.style.top = "4px";
          break;
        case "S":
          this.phoneMenu.style.top = maxBottom + "px";
          break;
        case "E":
          this.phoneMenu.style.left = "4px";
          break;
        case "O":
          this.phoneMenu.style.left = maxRight + "px";

        default:
          break;
      }
      this.direction = "";
      this.lastMenuPosition = [-1, -1];

      //delay for transition
      let timer = window.setInterval(() => {
        document.getElementsByTagName("body")[0].style.overflow = "auto";
      }, 500);
    },
  },
};
</script>

<style>
.phoneMenu {
  position: fixed;
  background: white;
  top: -10px;
  right: -10px;
  border-radius: 50%;
  border: 5px var(--main-color) solid;
  border-top-right-radius: 10%;
  height: 80px;
  width: 80px;
  z-index: 7;
  display: flex;
  align-items: center;
  justify-content: center;
  /*box-shadow: 0px 0px 0 1px white;*/
  display: none;
}

.phoneMenu i {
  color: var(--dark-color);
  transition: 0.3s ease;
}

.phoneMenu img {
  width: 40px;
}

@media all and (max-width: 990px) {
  .phoneMenu {
    display: flex;
  }
}
</style>